import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FaCrown } from 'react-icons/fa';

import LoginButtons from 'components/LoginButtons';
import Badge from 'components/Badge';
import event from 'utils/event';

// import userActions from 'store/user/actions';
import quizActions from 'store/quiz/actions';
import quizSelectors from 'store/quiz/selectors';
import badgeSelectors from 'store/badge/selectors';
import badgeActions from 'store/badge/actions';
import extraActions from 'store/extra/actions';
import modalActions from 'store/modal/actions';
import userActions from 'store/user/actions';

import { YELLOW } from 'root/theme';

import {
  HeaderText,
  SubHeader,
  ContentContainer,
  AnonScoreUpdateContainer,
  BarContainer,
  Bar,
  Username,
  Progress,
} from './AnonScoreUpdate.styles';

export class AnonScoreUpdate extends Component {
  componentDidMount() {
    const { setSignUpModal, type } = this.props;
    const contentType = setSignUpModal();
    event(`anon-score`, [`alert`, `anon-score-update`, `${type}-${contentType}`]);
    this.getContent(contentType);
  }

  getContent = (type) => {
    const {
      getBadge,
      selectedQuiz,
      getTopUser,
      selectBadge,
    } = this.props;

    switch (type) {
      case `progress`:
        break;
      case `badge`:
        selectBadge(`answered_10`);
        getBadge(`answered_10`);
        break;
      case `topLeaderboard`:
        getTopUser(selectedQuiz.id);
        break;
      case `score`:
        break;
      default:
        break;
    }
  }

  login = (signupFunc) => {
    const { contentType, onClose, type } = this.props;
    signupFunc(`${type}-${contentType}`);
    if (type === `modal`) {
      onClose();
    }
  }

  render() {
    const {
      anonymous,
      facebookLogin,
      gmailLogin,
      contentType,
      selectedQuiz,
      selectedBadge,
      quizMeta,
    } = this.props;

    let text = ``;
    let component = null;


    switch (contentType) {
      case `progress`:
        text = `Don't lose all your progress. Sign up to save your scores!`;
        component = (<ContentContainer>
          <SubHeader>{ selectedQuiz.name }</SubHeader>
          <Progress>
            { `${selectedQuiz.question_count - selectedQuiz.questions.length} / ${selectedQuiz.question_count}` }
          </Progress>
          <BarContainer>
            <Bar
              width={ Math.round(((selectedQuiz.question_count - selectedQuiz.questions.length) / selectedQuiz.question_count) * 100) } // eslint-disable-line
            />
          </BarContainer></ContentContainer>);
        break;
      case `badge`:
        text = `You could be earning badges for answering questions!`;
        component = (<ContentContainer><Badge
          data={ selectedBadge || {} }
          imgHeight={ 100 }
          imgWidth={ 100 }
        /></ContentContainer>);
        break;
      case `topLeaderboard`:
        text = `Think you can beat our ${selectedQuiz.name} champ? Sign up to see your rank.`;
        component = (
          <ContentContainer row>
            <SubHeader> Current Leader </SubHeader>
            <Username> <FaCrown color={ YELLOW } /> { quizMeta.topUser } </Username>
          </ContentContainer>);
        break;
      case `score`:
        text = `You would have earned ${anonymous.score} points so far if you were signed in`;
        break;
      default:
        text = `You would have earned ${anonymous.score} points so far if you were signed in`;
    }

    return (
      <AnonScoreUpdateContainer>
        <HeaderText> { text } </HeaderText>
        { component }
        <LoginButtons
          facebookLogin={ () => this.login(facebookLogin) }
          gmailLogin={ () => this.login(gmailLogin) }
        />
      </AnonScoreUpdateContainer>
    );
  }
}

AnonScoreUpdate.propTypes = {
  facebookLogin: PropTypes.func.isRequired,
  gmailLogin: PropTypes.func.isRequired,
  getBadge: PropTypes.func.isRequired,
  contentType: PropTypes.string,
  anonymous: PropTypes.object,
  selectedQuiz: PropTypes.object,
  getTopUser: PropTypes.func.isRequired,
  selectBadge: PropTypes.func.isRequired,
  setSignUpModal: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  quizMeta: PropTypes.object,
  selectedBadge: PropTypes.object,
  type: PropTypes.string.isRequired,
};


export default connect((state) => {
  return {
    anonymous: state.result.anonymous,
    contentType: state.extra.alertTypes.signUp,
    selectedQuiz: quizSelectors.selectedQuiz(state),
    selectedBadge: badgeSelectors.selected(state),
    quizMeta: quizSelectors.selectedQuizMeta(state),
  };
}, {
  getBadge: badgeActions.getBadge,
  selectBadge: badgeActions.selectBadge,
  getTopUser: quizActions.getTopUser,
  setSignUpModal: extraActions.setSignUpModal,
  hideModal: modalActions.hideModal,
  facebookLogin: userActions.facebookLogin,
  gmailLogin: userActions.gmailLogin,
})(AnonScoreUpdate);
